// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gallery-section {
  background: transparent;
  padding: 0;
  margin-bottom: 2rem;
}

/* Área principal de imagen */
.main-image-container {
  position: relative;
  margin-bottom: 1.5rem;
}

.main-image-display {
  background: #f5f5f5;
  border-radius: 12px;
  height: 600px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: hidden;
  position: relative;
}

.main-image-display:hover {
  background: #f0f0f0;
}

.main-image-display:hover .main-image {
  opacity: 0.9;
  transform: scale(1.02);
}

.image-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.placeholder-icon {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.placeholder-icon.small {
  transform: scale(0.6);
}

.placeholder-icon i {
  font-size: 4rem;
  color: #666;
}

.placeholder-icon.small i {
  font-size: 2.5rem;
  color: #666;
}

.plus-icon {
  position: absolute;
  top: -10px;
  right: -10px;
  background: #f09502;
  color: white;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
}

.placeholder-icon.small .plus-icon {
  width: 20px;
  height: 20px;
  font-size: 12px;
  top: -8px;
  right: -8px;
}

.main-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background-color: #f5f5f5;
  border-radius: 12px;
}

/* Botones sutiles derecha arriba */
.image-actions-top-right {
  position: absolute;
  top: 15px;
  right: 15px;
  display: flex;
  gap: 8px;
  z-index: 20;
}

.action-icon-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.85);
  color: #333;
  border: 1px solid rgba(0,0,0,0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(4px);
}

.action-icon-btn:hover {
  background: #fff;
  transform: scale(1.1);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.action-icon-btn.edit { color: #f09502; }
.action-icon-btn.delete { color: #dc3545; }

/* Botón de portada */
.set-cover-button {
  position: absolute;
  top: 15px;
  left: 15px;
  background: rgba(100, 100, 100, 0.7);
  color: white;
  border: 1px solid rgba(255,255,255, 0.5);
  border-radius: 8px;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
  font-weight: 500;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(4px);
}

.set-cover-button:hover {
  background: rgba(100, 100, 100, 0.9);
  transform: translateY(-1px);
}

.set-cover-button.active-cover {
  background: rgba(240, 149, 2, 0.9);
  border-color: rgba(240, 149, 2, 1);
}

.set-cover-button.active-cover:hover {
  background: rgba(240, 149, 2, 1);
}

.set-cover-button i {
  font-size: 14px;
}

/* Botón de navegación */
.nav-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: #f09502;
  color: white;
  border: none;
  border-radius: 50%;
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  font-size: 16px;
  z-index: 10;
}

.nav-button:hover {
  background: #e08502;
  transform: translateY(-50%) scale(1.1);
}

.right-nav {
  right: 15px;
}

.left-nav {
  left: 15px;
}

/* Fila de miniaturas */
.thumbnails-row {
  display: flex;
  justify-content: space-between; /* Distribución equitativa */
  gap: 0.5rem; /* Reducido de 1rem a 0.5rem */
  padding: 0.5rem 0;
  width: 100%;
}

.thumbnail-container {
  background: #f5f5f5;
  border-radius: 8px;
  flex: 1; /* Se adapta al espacio disponible */
  max-width: 180px; /* Aumentado de 150px a 180px */
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.thumbnail-container:hover {
  background: #f0f0f0;
  transform: translateY(-2px);
}

.thumbnail-container.selected {
  border: 3px solid #f09502;
  background: #fff5e6;
}

/* Estilos para Drag and Drop */
.cdk-drag-preview {
  box-sizing: border-box;
  border-radius: 8px;
  box-shadow: 0 5px 15px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);
  background: #fff;
  z-index: 1000 !important;
  opacity: 0.95;
}

.cdk-drag-animating {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

.thumbnails-row.cdk-drop-list-dragging .thumbnail-container:not(.cdk-drag-placeholder) {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
/* Fin estilos Drag and Drop */

.thumbnail-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.thumbnail-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background-color: #f5f5f5;
  border-radius: 8px;
}

/* Botón de cambiar miniatura */
.change-thumbnail-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  background: rgba(240, 149, 2, 0.9);
  color: white;
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  z-index: 10;
}

.change-thumbnail-btn:hover {
  background: rgba(240, 149, 2, 1);
  transform: scale(1.1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.add-image-thumbnail {
  background: #f5f5f5;
  border-radius: 8px;
  flex: 1; /* Se adapta al espacio disponible */
  max-width: 180px; /* Aumentado de 150px a 180px */
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px dashed #ccc;
}

.add-image-thumbnail:hover {
  background: #f0f0f0;
  border-color: #f09502;
  transform: translateY(-2px);
}

/* Responsive */
@media (max-width: 768px) {
  .main-image-display {
    height: 300px;
  }
  
  .thumbnails-row {
    gap: 0.25rem; /* Espaciado aún más reducido en móvil */
  }
  
  .thumbnail-container,
  .add-image-thumbnail {
    max-width: 120px; /* Aumentado de 100px a 120px en móvil */
    height: 80px;
  }
  
  .placeholder-icon i {
    font-size: 3rem;
  }
  
  .placeholder-icon.small i {
    font-size: 2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/components/new-proyect/new-project-gallery/new-project-gallery.component.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,UAAU;EACV,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,WAAW;EACX,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA,wBAAwB,cAAc,EAAE;AACxC,0BAA0B,cAAc,EAAE;;AAE1C,qBAAqB;AACrB;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,oCAAoC;EACpC,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,wCAAwC;EACxC,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,8BAA8B,EAAE,4BAA4B;EAC5D,WAAW,EAAE,8BAA8B;EAC3C,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,OAAO,EAAE,oCAAoC;EAC7C,gBAAgB,EAAE,+BAA+B;EACjD,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,sBAAsB;EACtB,kBAAkB;EAClB,sHAAsH;EACtH,gBAAgB;EAChB,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,sDAAsD;AACxD;AACA,8BAA8B;;AAE9B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,kCAAkC;EAClC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,wCAAwC;EACxC,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,OAAO,EAAE,oCAAoC;EAC7C,gBAAgB,EAAE,+BAA+B;EACjD,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,YAAY,EAAE,wCAAwC;EACxD;;EAEA;;IAEE,gBAAgB,EAAE,wCAAwC;IAC1D,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".gallery-section {\n  background: transparent;\n  padding: 0;\n  margin-bottom: 2rem;\n}\n\n/* Área principal de imagen */\n.main-image-container {\n  position: relative;\n  margin-bottom: 1.5rem;\n}\n\n.main-image-display {\n  background: #f5f5f5;\n  border-radius: 12px;\n  height: 600px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  overflow: hidden;\n  position: relative;\n}\n\n.main-image-display:hover {\n  background: #f0f0f0;\n}\n\n.main-image-display:hover .main-image {\n  opacity: 0.9;\n  transform: scale(1.02);\n}\n\n.image-placeholder {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n}\n\n.placeholder-icon {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.placeholder-icon.small {\n  transform: scale(0.6);\n}\n\n.placeholder-icon i {\n  font-size: 4rem;\n  color: #666;\n}\n\n.placeholder-icon.small i {\n  font-size: 2.5rem;\n  color: #666;\n}\n\n.plus-icon {\n  position: absolute;\n  top: -10px;\n  right: -10px;\n  background: #f09502;\n  color: white;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: bold;\n}\n\n.placeholder-icon.small .plus-icon {\n  width: 20px;\n  height: 20px;\n  font-size: 12px;\n  top: -8px;\n  right: -8px;\n}\n\n.main-image {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  background-color: #f5f5f5;\n  border-radius: 12px;\n}\n\n/* Botones sutiles derecha arriba */\n.image-actions-top-right {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  display: flex;\n  gap: 8px;\n  z-index: 20;\n}\n\n.action-icon-btn {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.85);\n  color: #333;\n  border: 1px solid rgba(0,0,0,0.1);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  backdrop-filter: blur(4px);\n}\n\n.action-icon-btn:hover {\n  background: #fff;\n  transform: scale(1.1);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n.action-icon-btn.edit { color: #f09502; }\n.action-icon-btn.delete { color: #dc3545; }\n\n/* Botón de portada */\n.set-cover-button {\n  position: absolute;\n  top: 15px;\n  left: 15px;\n  background: rgba(100, 100, 100, 0.7);\n  color: white;\n  border: 1px solid rgba(255,255,255, 0.5);\n  border-radius: 8px;\n  padding: 8px 12px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 14px;\n  font-weight: 500;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n  backdrop-filter: blur(4px);\n}\n\n.set-cover-button:hover {\n  background: rgba(100, 100, 100, 0.9);\n  transform: translateY(-1px);\n}\n\n.set-cover-button.active-cover {\n  background: rgba(240, 149, 2, 0.9);\n  border-color: rgba(240, 149, 2, 1);\n}\n\n.set-cover-button.active-cover:hover {\n  background: rgba(240, 149, 2, 1);\n}\n\n.set-cover-button i {\n  font-size: 14px;\n}\n\n/* Botón de navegación */\n.nav-button {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  background: #f09502;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 45px;\n  height: 45px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n  font-size: 16px;\n  z-index: 10;\n}\n\n.nav-button:hover {\n  background: #e08502;\n  transform: translateY(-50%) scale(1.1);\n}\n\n.right-nav {\n  right: 15px;\n}\n\n.left-nav {\n  left: 15px;\n}\n\n/* Fila de miniaturas */\n.thumbnails-row {\n  display: flex;\n  justify-content: space-between; /* Distribución equitativa */\n  gap: 0.5rem; /* Reducido de 1rem a 0.5rem */\n  padding: 0.5rem 0;\n  width: 100%;\n}\n\n.thumbnail-container {\n  background: #f5f5f5;\n  border-radius: 8px;\n  flex: 1; /* Se adapta al espacio disponible */\n  max-width: 180px; /* Aumentado de 150px a 180px */\n  height: 120px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.thumbnail-container:hover {\n  background: #f0f0f0;\n  transform: translateY(-2px);\n}\n\n.thumbnail-container.selected {\n  border: 3px solid #f09502;\n  background: #fff5e6;\n}\n\n/* Estilos para Drag and Drop */\n.cdk-drag-preview {\n  box-sizing: border-box;\n  border-radius: 8px;\n  box-shadow: 0 5px 15px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);\n  background: #fff;\n  z-index: 1000 !important;\n  opacity: 0.95;\n}\n\n.cdk-drag-animating {\n  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n}\n\n.thumbnails-row.cdk-drop-list-dragging .thumbnail-container:not(.cdk-drag-placeholder) {\n  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n}\n/* Fin estilos Drag and Drop */\n\n.thumbnail-placeholder {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n}\n\n.thumbnail-image {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  background-color: #f5f5f5;\n  border-radius: 8px;\n}\n\n/* Botón de cambiar miniatura */\n.change-thumbnail-btn {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  background: rgba(240, 149, 2, 0.9);\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 10px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  z-index: 10;\n}\n\n.change-thumbnail-btn:hover {\n  background: rgba(240, 149, 2, 1);\n  transform: scale(1.1);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n\n.add-image-thumbnail {\n  background: #f5f5f5;\n  border-radius: 8px;\n  flex: 1; /* Se adapta al espacio disponible */\n  max-width: 180px; /* Aumentado de 150px a 180px */\n  height: 120px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border: 2px dashed #ccc;\n}\n\n.add-image-thumbnail:hover {\n  background: #f0f0f0;\n  border-color: #f09502;\n  transform: translateY(-2px);\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .main-image-display {\n    height: 300px;\n  }\n  \n  .thumbnails-row {\n    gap: 0.25rem; /* Espaciado aún más reducido en móvil */\n  }\n  \n  .thumbnail-container,\n  .add-image-thumbnail {\n    max-width: 120px; /* Aumentado de 100px a 120px en móvil */\n    height: 80px;\n  }\n  \n  .placeholder-icon i {\n    font-size: 3rem;\n  }\n  \n  .placeholder-icon.small i {\n    font-size: 2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
